import { render, staticRenderFns } from "./explosiveText.vue?vue&type=template&id=0c08b9d7&scoped=true&"
import script from "./explosiveText.vue?vue&type=script&lang=js&"
export * from "./explosiveText.vue?vue&type=script&lang=js&"
import style0 from "./explosiveText.vue?vue&type=style&index=0&id=0c08b9d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c08b9d7",
  null
  
)

export default component.exports